import { AppFunctionComponent } from "../../../types"
import React from "react"
import useTranslationHook from "../../../hooks/use-translation.hook"
import { CopyrightsWrapper } from "./copyrights.styled"

const Copyrights: AppFunctionComponent = () => {
  const { translate } = useTranslationHook()
  return (
    <CopyrightsWrapper>
      {new Date().getFullYear()} © Mudita {translate("copyrights-notice")}
    </CopyrightsWrapper>
  )
}

export default Copyrights
